import React from "react"

import Container from "@ecom/ui/components/Container"
import Box from "@ecom/ui/components/Box"
import Button from "@ecom/ui/components/Button"
import { makeStyles } from "@material-ui/core/styles"
import PhoneMain from "@ecom/ui/components/PhoneMain"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import { scrollToPersonalForm } from "../../../helpers/scrollToPersonalForm"
import * as styles from "./UnicHeader.module.scss"

export const UnicHeader = (props: any) => {
  const {
    children,
    Logo,
    onLogoClick,
    ButtonProps,
    buttonText,
    phones = "8 (800) 100-77-72",
  } = props

  const useStyles = makeStyles((theme) => ({
    navigation: {
      height: 64,

      [theme.breakpoints.up("sm")]: {
        height: 80,
      },

      [theme.breakpoints.up("md")]: {
        height: 88,
      },
    },
  }))

  const classes = useStyles()

  function handleClick() {
    scrollToPersonalForm()
    pushToDataLayer({
      event: "buttonClick",
      name: "Зарегистрироваться",
      placement: "registration partner",
    })
  }

  return (
    <header className={styles.header}>
      <Container className={styles.header}>
        <nav>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className={classes.navigation}
          >
            <button
              aria-label="go home page"
              type="button"
              onClick={onLogoClick}
              className={styles.logo}
            >
              <Logo />
            </button>
            {children}
            <Box display="flex" alignItems="center">
              {buttonText ? (
                <Button {...ButtonProps} className={styles.btn} onClick={handleClick}>
                  {buttonText}
                </Button>
              ) : (
                <PhoneMain phone={phones} className={styles.unicnumber} />
              )}
            </Box>
          </Box>
        </nav>
      </Container>
    </header>
  )
}
